module.exports = (parcelRequire.load("1eWoD")).then(() => parcelRequire('1KssV'));